import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'

export default class BriefingHeader extends PureComponent {
    render() {
        return (
            <div className="col-xs-12">
                <h3>
                    <Link className="link-icon" to={this.props.backHref} title={this.props.backTitle}>
                        <i className="spark-icon-arrow-curve-left spark-icon--md"></i>
                    </Link>
                    &nbsp;&nbsp;{this.props.text}
                </h3>
            </div>
        )
    }
}

BriefingHeader.propTypes = {
    backHref: PropTypes.string.isRequired,
    backTitle: PropTypes.string,
    text: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/screens/briefing/components/Header.js